/* global wp */
import FormField from './form-field';
import PasswordInput from './password-input';

const { __ } = wp.i18n;
const { useState } = wp.element;

const PasswordField = (props) => {
	const { onInput, onError } = props;
	const [error, setError] = useState('');

	const handleChange = (value) => {
		onInput(value);

		if (value) {
			setError('');
		} else {
			setError(__('Password is required.', 'wpmudev'));
		}

		if (error) {
			onError(true);
		} else {
			onError(false);
		}
	};

	return (
		<FormField
			{...props}
			onInput={(e) => handleChange(e)}
			formControl={PasswordInput}
		/>
	);
};

export default PasswordField;
